import logger from "@next/core-logger"
import {IncomingHttpHeaders} from "http"
import type {AxiosError} from "axios"
import {BundleSummaryData} from "models/productSummaryApi/bundle"
import axios from "../../utils/axios"
import {ProductSummaryData} from "../../models/productSummaryApi/product"
import {SuitSummaryData} from "../../models/productSummaryApi/suit"
import {SofaSummaryData} from "../../models/productSummaryApi/sofa"
import ProductSummaryApi from "../../config/api/productSummary"

const getProductSummaryJsonDataApi = ProductSummaryApi("getProductSummaryJson")

// this will always be called server-side on first render and subsequent server-side renders
export const getProductSummaryJson = async (
    headers: IncomingHttpHeaders,
    apiProxyVersion: string,
    itemNumber: string | number,
    type: string,
): Promise<{response: ProductSummaryData | SuitSummaryData | SofaSummaryData | BundleSummaryData; responseHeaders}> => {
    try {
        const response = await axios({
            method: getProductSummaryJsonDataApi.method,
            url: `${getProductSummaryJsonDataApi.localEndpoint(apiProxyVersion, itemNumber, type)}`,
            headers: headers as {
                [header: string]: string
            },
            params: {
                searchType: "serverSide",
            },
        })
        return {
            response: response.data,
            responseHeaders: response.headers,
        }
    } catch (err) {
        const error = err as AxiosError
        if (error.response) {
            // Axios interceptors log this error already
            throw error
        }
        logger.error(error)
        throw error
    }
}
